import { mapGetters } from 'vuex';
import Forms from './../../utils/forms/forms';
import depositService from './../../services/productDeposit';
import productService from './../../services/product';
import taxService from './../../services/tax';
import productTransformer from './../../transformers/product';

export default {
  data() {
    return {
      form: new Forms({
        number: {
          type: 'text',
          value: '',
        },
        externalId: {
          type: '',
          value: '',
        },
        name: {
          type: 'text',
          value: '',
        },
        description: {
          type: 'textarea',
          value: '',
        },
        price: {
          type: 'number',
          value: '',
        },
        taxId: {
          type: 'select',
          value: '',
        },
        productDepositCheckbox: {
          type: 'checkbox',
          value: '',
        },
        productDepositId: {
          type: 'select',
          value: '',
        },
        vintage: {
          value: '',
          type: 'text',
        },
        bottle_volume: {
          value: '',
          type: 'number',
        },
        packaging_type: {
          value: '',
          type: 'text',
        },
        gtin: {
          value: '',
          type: 'text',
        },

      }),
      product: {},
      loading: false,
    };
  },

  props: {
    productId: {
      type: [String, Number],
      required: true,
    },

    orderProduct: {
      type: Object,
      required: false,
    },

    isEdi: {
      type: Boolean,
      default: false,
    },

    onMounted: {
      type: Function,
      default: () => {},
    },

    updated: {
      type: Function,
      required: false,
    },
  },

  computed: {
    ...mapGetters({
      deposits: 'allProductDeposits',
      taxes: 'allTaxes',
    }),
  },

  watch: {
    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} deposits    The all deposits list.
     */
    deposits(deposits) {
      this.form.setOptions('productDepositId', deposits.all);
    },

    /**
     * Watches deposit checkbox and display deposit select box accordingly.
     *
     * @param  {Boolean} value Checked or not.
     */
    'form.productDepositCheckbox': function (value) {
      if (value) {
        this.form.showField('productDepositId');
      } else {
        this.form.hideField('productDepositId');
      }
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} taxes    The taxes list.
     */
    taxes(taxes) {
      this.form.setOptions('taxId', taxes.all.map(tax => ({ id: tax.id, name: tax.taxPercentage })));
    },
  },

  mounted() {
    if (this.isEdi) {
      this.form.disableField('name');
      this.form.disableField('price');
      this.form.disableField('taxId');
    }

    this.form.disableField('description');
    this.form.disableField('gtin');
    this.form.disableField('packaging_type');
    this.form.disableField('bottle_volume');
    this.form.disableField('vintage');
    this.form.disableField('number');
    this.form.disableField('externalId');

    depositService.all();
    taxService.all();
    this.loading = true;

    productService.show(this.productId).then((product) => {
      this.loading = false;
      if (product.productDepositId) {
        this.form.productDepositCheckbox = true;
      } else {
        this.form.productDepositCheckbox = false;
        this.form.hideField('productDepositId');
      }
      this.product = product;
      this.form.assignData(product);
    });
  },

  methods: {
    onSubmit() {
      let that = this;
      const data = Object.assign({}, this.product, this.form.data());
      productService.quickUpdate(this.productId, productTransformer.send(data)).then(() => {
       // console.log(this.updated)
        //this.onMounted();
        if(this.updated != undefined) {

          that.updated(data, that.orderProduct).then(() => {
               that.$emit('close');
          }).catch(()=>{
              that.$emit('close');
          });
         
        }else{
           that.$emit('close');
        }
       
       
      }).catch((error) => {
        this.form.recordErrors(error);
      });
    },
  },

  components: {
    VForm: require('./../form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/quickProductEdit/quickProductEdit.js